var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cms-social-share-block", style: _vm.containerStyle },
    [
      _vm.labelText
        ? _c("span", { staticClass: "cms-social-share-block__label" }, [
            _vm._v(_vm._s(_vm.labelText)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cms-social-share-block__buttons" },
        _vm._l(_vm.activePlatforms, function (platform, idx) {
          return _c(
            "a",
            {
              key: idx,
              staticClass: "cms-social-share-block__btn",
              class: [
                "cms-social-share-block__btn--" + _vm.resolvedStyle,
                "cms-social-share-block__btn--" + _vm.size,
                _vm.resolvedShowLabels
                  ? "cms-social-share-block__btn--has-label"
                  : "",
              ],
              style: _vm.btnStyle(platform),
              attrs: {
                href: _vm.shareUrl(platform),
                target: "_blank",
                rel: "noopener noreferrer",
                title: "Share on " + platform.label,
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.openShare(platform)
                },
              },
            },
            [
              _c("i", { class: "fa fa-" + platform.icon }),
              _vm._v(" "),
              _vm.resolvedShowLabels
                ? _c(
                    "span",
                    { staticClass: "cms-social-share-block__btn-label" },
                    [_vm._v(_vm._s(platform.label))]
                  )
                : _vm._e(),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }